import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Layout from "./components/layout/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Campaigns from "./pages/Campaigns";
import CampaignDetail from "./pages/CampaignDetail";
import ContentStudio from "./pages/ContentStudio";
import SocialHub from "./pages/SocialHub";
import EmailMarketing from "./pages/EmailMarketing";
import SEOTools from "./pages/SEOTools";
import AdManager from "./pages/AdManager";
import Analytics from "./pages/Analytics";
import Automations from "./pages/Automations";
import Autopilot from "./pages/Autopilot";
import Settings from "./pages/Settings";
import CreateContent from "./pages/CreateContent";
import CreateCampaign from "./pages/CreateCampaign";
import CreateAd from "./pages/CreateAd";
import CreateEmail from "./pages/CreateEmail";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }
  return user ? <>{children}</> : <Navigate to="/login" replace state={{ from: location.pathname }} />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/campaigns" element={<Campaigns />} />
                <Route path="/campaigns/create" element={<CreateCampaign />} />
                <Route path="/campaigns/:id" element={<CampaignDetail />} />
                <Route path="/content" element={<ContentStudio />} />
                <Route path="/content/create" element={<CreateContent />} />
                <Route path="/social" element={<SocialHub />} />
                <Route path="/email" element={<EmailMarketing />} />
                <Route path="/email/create" element={<CreateEmail />} />
                <Route path="/seo" element={<SEOTools />} />
                <Route path="/ads" element={<AdManager />} />
                <Route path="/ads/create" element={<CreateAd />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/automations" element={<Automations />} />
                <Route path="/autopilot" element={<Autopilot />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
